module.exports = __webpack_public_path__ + "static/media/biomechanics-assessment.27e44d21.jpg";